import React from "react";
import ReactApexChart from "react-apexcharts";

interface SectorData {
    sector: string;
    count: number;
}

interface Props {
    sectorDistribution: SectorData[];
}

const SectorDistributionTreeMap: React.FC<Props> = ({ sectorDistribution }) => {
    const fillColor = "#E43E9F";
    const data = (sectorDistribution || []).map((entry) => ({
        x: entry.sector,
        y: entry.count,
        fillColor,
    }));

    const options = {
        chart: {
            type: "treemap" as const,
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={[{ data }]}
                type="treemap"
                height={350}
            />
        </div>
    );
};

export default SectorDistributionTreeMap;
